// extracted by mini-css-extract-plugin
export var confirm = "search-module--confirm--b4d48";
export var input = "search-module--input--9fc99";
export var searchBar = "search-module--searchBar--00df5";
export var searchBarWrapper = "search-module--searchBarWrapper--c931c";